import { createStyles, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() =>
  createStyles({
    "@global": {
      "*": {
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
        caretColor: "transparent",
      },
      html: {
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        height: "100%",
        width: "100%"
      },
      body: {
        height: "100%",
        width: "100%",
        overflow: "hidden"
      },
      "#root": {
        height: "100%",
        width: "100%"
      },
      "input, textarea, [contenteditable='true']": {
        caretColor: "auto",
      },
    }
  })
);

const GlobalStyles = () => {
  useStyles();

  return null;
};

export default GlobalStyles;
